import { PhoneLockIcon } from './PhoneLockIcon';

/**
 * author: Google
 * id 31349A83-A803-48DF-98C8-55D5E27B81E4
 * name phone-lock
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-lock.svg
 * tags
 * - Cellphone / Phone 
 * - Lock 
 */
export const TelephoneLockedIcon = PhoneLockIcon;
export default TelephoneLockedIcon